import { PsUtilities } from 'components';
import { mainRestApi } from '@state/stores/restApi/rest-api';
import {
  BuyerContractArchiveForm,
  BuyerContractManagementDetail,
  CreateBuyerContractArgs,
  UpdateBuyerContractArgs
} from './models';

const BASE_URL = '/secured/buyer/contract-management/contracts';

export const buyerContractManagementApi = mainRestApi.injectEndpoints({
  endpoints: (build) => ({
    getBuyerContract: build.query<
      BuyerContractManagementDetail,
      { contractId: number }
    >({
      query: ({ contractId }) => ({
        url: `${BASE_URL}/${contractId}`,
        method: 'GET'
      }),
      providesTags: (_result, _error, { contractId }) => [
        { type: 'BUYER_CONTRACT_MANAGEMENT_DETAIL', id: contractId }
      ]
    }),
    createBuyerContract: build.mutation<
      BuyerContractManagementDetail,
      CreateBuyerContractArgs
    >({
      query: ({ form, attachments }) => ({
        url: BASE_URL,
        method: 'POST',
        data: PsUtilities.createFormRequestParts(form, attachments)
      })
    }),
    updateBuyerContract: build.mutation<
      BuyerContractManagementDetail,
      UpdateBuyerContractArgs
    >({
      query: ({ contractId, form, attachments }) => ({
        url: `${BASE_URL}/${contractId}`,
        method: 'PUT',
        data: PsUtilities.createFormRequestParts(form, attachments)
      }),
      invalidatesTags: (_result, _error, { contractId }) => [
        { type: 'BUYER_CONTRACT_MANAGEMENT_DETAIL', id: contractId }
      ]
    }),
    changeBuyerContractArchived: build.mutation<
      BuyerContractManagementDetail,
      { contractId: number; form: BuyerContractArchiveForm }
    >({
      query: ({ contractId, form }) => ({
        url: `${BASE_URL}/${contractId}/archived`,
        method: 'PATCH',
        data: form
      }),
      invalidatesTags: (_result, _error, { contractId }) => [
        { type: 'BUYER_CONTRACT_MANAGEMENT_DETAIL', id: contractId }
      ]
    }),
    deleteBuyerContract: build.mutation<void, { contractId: number }>({
      query: ({ contractId }) => ({
        url: `${BASE_URL}/${contractId}`,
        method: 'DELETE'
      }),
      invalidatesTags: (_result, _error, { contractId }) => [
        { type: 'BUYER_CONTRACT_MANAGEMENT_DETAIL', id: contractId }
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useGetBuyerContractQuery,
  useCreateBuyerContractMutation,
  useUpdateBuyerContractMutation,
  useChangeBuyerContractArchivedMutation,
  useDeleteBuyerContractMutation
} = buyerContractManagementApi;
